export default{
    getUserInfo: '/user/getuserinfo',
    // 获取登陆用户信息
    getData: 'bloodsugar/getLatestBloodsugar',
}